/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Form, Button, Modal, Header, Icon, Grid } from 'semantic-ui-react'
import styled from 'styled-components'

import MerchantField from '../../../../components/specialDeal/fields/restaurantsField'

import MerchantActions from '../../../../reducers/restaurantReducer'
import MerchandiseCodeActions from '../../../../reducers/merchandiseCodeReducer'
import utils from '../../../../utils'

const FileUploadWrapper = styled.div`
  width: 112px;
  height: 112px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 5px;
  border: 1px solid #efefef;
  flex-direction: column;
  background-color: ${props => props.hasFile ? '#fff' : '#efefef'};
`

const FileName = styled.div`
  margin-top: 3px;
  width: 100px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-size: 11px;
  text-align: center;
`

class MerchandiseCodeForm extends Component {
  btnSubmitRef = React.createRef()

  fileUploadRef = React.createRef()

  state = {
    merchantId: null,
    startingCol: 1,
    startingRow: 1,
    file: null,
  }

  componentDidMount() {
    const { fetchMerchants, merchantLoaded } = this.props

    if (!merchantLoaded) fetchMerchants()
  }

  generateCodes = async () => {
    const { file, startingRow, startingCol } = this.state

    const rows = await utils.helpers.getJsonDataFromExcel(file)
    const codes = {}

    for (let row = 1; row <= rows.length; row += 1) {
      const columns = rows[row - 1]

      for (let col = 1; col <= columns.length; col += 1) {
        const value = columns[col - 1]

        if (row >= startingRow && col >= startingCol)
          codes[value] = {
            code: value,
            redeemed: false,
          }
      }
    }

    return codes
  }

  onSubmit = async () => {
    const { saveMerchandiseCode, onClose, merchants } = this.props
    const { merchantId } = this.state

    const merchant = merchants[merchantId]
    const codes = await this.generateCodes()

    // eslint-disable-next-line no-alert
    if (Object.keys(codes).length === 0) return alert('No code available in excel file')

    saveMerchandiseCode({
      merchant_id: merchantId,
      merchant_name: merchant.name,
      created_at: Date.now(),
      codes
    }, onClose)
  }

  onFileChange = async e => {
    const file = e.target.files[0]

    if (!file) return

    this.setState({ file })
  }

  render() {
    const { visible, onClose, loading, merchantLoaded, merchants } = this.props
    const { startingRow, startingCol, file, merchantId } = this.state

    const disabledSave = loading || !merchantLoaded || !file || !merchantId

    return (
      <Modal open={visible} size="small" style={{ marginTop: 0 }}>
        <Header content="Add Merchandise Codes" />
        <Modal.Content style={{ maxHeight: 500, overflow: 'auto' }} className="branch-form">
          <Form
            onSubmit={this.onSubmit}
            ref={ref => {
              this.formRef = ref
            }}
            disabled={loading}
          >
            <Grid columns={2}>
              <Grid.Row>
                <Grid.Column>
                  <Form.Group widths="equal">
                    <MerchantField restaurants={merchants} value={merchantId} onChange={value => this.setState({ merchantId: value })} />
                  </Form.Group>
                  <Form.Group widths="equal">
                    <Form.Input
                      required
                      label="Starting Row"
                      type="number"
                      value={startingRow}
                      onChange={e => this.setState({ startingRow: e.target.value })}
                    />
                  </Form.Group>
                  <Form.Group widths="equal">
                    <Form.Input
                      required
                      label="Starting Column"
                      type="number"
                      value={startingCol}
                      onChange={e => this.setState({ startingCol: e.target.value })}
                    />
                  </Form.Group>
                </Grid.Column>
                <Grid.Column>
                  <Form.Group widths="equal">
                    <Form.Field>
                      <label>File Upload</label>
                      <FileUploadWrapper
                        onClick={() => this.fileUploadRef.click()}
                        hasFile={Boolean(file)}
                      >
                        {file ? (
                          <React.Fragment>
                            <Icon name="file excel" size="big" color="grey" />
                            <FileName>{file.name}</FileName>
                          </React.Fragment>
                        ) : (
                          <Icon name = "upload" size = "big" color = "grey" />
                        )}
                      </FileUploadWrapper>
                    </Form.Field>
                  </Form.Group>
                </Grid.Column>
              </Grid.Row>
            </Grid>
            <input
              hidden
              accept=".xlsx, .xls, .csv"
              type="file"
              onChange={this.onFileChange}
              ref={ref => {
                this.fileUploadRef = ref
              }}
            />
            <button
              type="submit"
              hidden
              ref={ref => {
                this.btnSubmitRef = ref
              }}
            />
          </Form>
        </Modal.Content>

        <Modal.Actions>
          <Button onClick={onClose} disabled={loading}>
            Close
          </Button>
          <Button
            icon
            color="black"
            onClick={() => this.btnSubmitRef.click()}
            loading={loading}
            disabled={disabledSave}
          >
            <Icon name="checkmark" /> Save
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }
}

const mapState = ({ restaurants, merchandiseCodes }) => ({
  loading: merchandiseCodes.saving,
  merchants: restaurants.data,
  merchantLoaded: restaurants.loaded,
})

const mapDispatch = {
  fetchMerchants: MerchantActions.fetchRestaurantsRequest,
  saveMerchandiseCode: MerchandiseCodeActions.saveMerchandiseCode,
}

export default connect(mapState, mapDispatch)(MerchandiseCodeForm)



// WEBPACK FOOTER //
// ./src/containers/rewards/MerchandiseCodes/components/Form.js